import Navbar1Combine from "./components/Header/Navbar1Combine";
import CombineBanner from "./components/Banner/WebBanner";
import CombinationCategoryCard2 from "./components/Categories/CombinationCategoryCard2";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container } from "react-bootstrap";
import "./App.css";
import "./assets/css/style.css"
import Footer from './components/Footer/footer'
import WhyHolxo from "./components/whyholxo/HolxoAbout";
function App() {
  return (
    <>
    <Container fluid className="p-0 m-0 bodyoverflowx">      
        <Navbar1Combine />
        <CombineBanner />
        <CombinationCategoryCard2 />
        <WhyHolxo />
        <Footer />
    </Container>
    </>
  );
}

export default App;
